(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.components:mxButton
	 * @module mx.components
	 * @restrict 'E'
	 * @scope {}
	 * @description Custom button component
	 * @param {string} label@ - Text to be displayed on button
	 * @param {string} icon@ - Name of Material Design icon to be displayed on button
	 * @param {string} styles@ - Styles to be applied to button <br /><i>Default: md-raised md-primary</i>
	 * @param {bool} focused@ - If true, a button should have input focus when the page loads <br /><i>Default: false</i>
	 * @param {function} click& - Button click handler
	 * @param {boolean} isDisabled=? - Specifies if button is disabled
	 * @usage <mx-button click='clickFn' label='A button' icon='check' focused='false' styles='btn-style'></mx-button>
	 */
	angular.module('mx.components').component('mxButton', {
		bindings: {
			label: '@',
			icon: '@',
			styles: '@',
			click: '&',
			focused: '@',
			isDisabled: '<?',
		},
		controller: MxButtonCtrl,
		controllerAs: 'vm',
		templateUrl: 'mx-button/mx-button.html',
	});

	MxButtonCtrl.$inject = ['$timeout'];

	function MxButtonCtrl($timeout) {
		var vm = this;

		vm.$onInit = function () {
			vm.isProcessing = false;
		};

		vm.onButtonClick = function () {
			if (vm.isProcessing) {
				return;
			}
			vm.isProcessing = true;
			if (vm.click) {
				vm.click();
			}
			$timeout(function () {
				vm.isProcessing = false;
			}, 100);
		};
	}
})();
